import { useMemo } from 'react';
import { doesExist } from 'utils/tsHelpers';
import { useRequirementCombinatorFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts/queryErrorState';
import { Combinator } from '../../../types';

export const useHasRequirementCombinatorError = (combinator: Combinator) => {
  const fieldPath = useRequirementCombinatorFieldPath();
  const { getHasErrorFromFieldPath } = useQueryErrorStateContext();
  const errorFromFieldPath = getHasErrorFromFieldPath(fieldPath);

  return useMemo(() => {
    if (doesExist(combinator)) return false;
    else return errorFromFieldPath;
  }, [combinator, errorFromFieldPath]);
};
